import { initJsPsych } from 'jspsych';
import store from 'store2';

const redirectInfo = {
  cdm: 'https://stanford-cogsci.org:8880/landing_page.html',
  demo: 'https://roar.stanford.edu/',
};

export const jsPsych = initJsPsych({
  show_progress_bar: true,
  auto_update_progress_bar: false,
  message_progress_bar: 'Progress Complete',
  on_finish: () => {
    const config = store.session.get('config');
    if (config.recruitment === 'cdm') {
      window.location.href = redirectInfo.cdm;
    }
    if (config.recruitment === 'demo') {
      window.location.href = redirectInfo.demo;
    }
  },
});
